import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestSettingsVerifyPost = {
    path: "/settings/verify",
    method: RouteHttpVerb.POST
};
export { locationRestSettingsVerifyPost };
